/**
 * Static Help Center FAQs for FAQPage JSON-LD (aligned with PHP HelpCenterFaqSchema).
 */
export const HELP_CENTER_FAQ_SCHEMA: { question: string; answer: string }[] = [
  {
    question: 'How do I create an account on Virtoly?',
    answer:
      'Click Sign Up, choose customer or expert, fill in your details, and verify your email to complete registration.',
  },
  {
    question: 'What is the difference between a customer and an expert account?',
    answer:
      'Customers post service requests, receive quotes, and hire professionals. Experts browse jobs, submit quotes, and get hired for work.',
  },
  {
    question: 'How does Virtoly work?',
    answer:
      'Customers post service needs, experts submit quotes, and once a quote is accepted work begins. Payments are processed securely through Virtoly.',
  },
  {
    question: 'Is Virtoly available in my area?',
    answer:
      'Virtoly is available across Canada. Experts set service areas and customers find professionals in their city.',
  },
  {
    question: 'How do I post a service request?',
    answer:
      'Select a service category and subcategory, provide project details including date and photos, choose an order type, and submit your order.',
  },
  {
    question: 'How does payment work on Virtoly?',
    answer:
      'When you accept a quote, payment is authorized. Your card is charged after the review period or when work is marked complete, per Virtoly payment terms.',
  },
  {
    question: 'What types of services does Virtoly offer?',
    answer:
      'Virtoly offers cleaning, handyman, moving, auto services, pet care, home improvement, tech help, and many other local service categories.',
  },
  {
    question: 'How do I get help from Virtoly support?',
    answer:
      'Visit the Help Center for FAQs or Contact Us to send a message. Logged-in users can also use in-app chat for support.',
  },
];

export function buildHelpCenterFaqJsonLd(pageUrl: string): object {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    '@id': `${pageUrl}#faq`,
    mainEntity: HELP_CENTER_FAQ_SCHEMA.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}
